const state = {
  customerBlockPage: null,
  mspBlockPage: null,
  globalBlockPage: null,
};

const getters = {
  customerBlockPage: (state) => state.customerBlockPage,
  mspBlockPage: (state) => state.mspBlockPage,
  globalBlockPage: (state) => state.globalBlockPage,
};

const actions = {
  // Customer Block page

  async fetchCustomerBlockPage({ commit }, { user_id }) {
    const response = await this._vm.$http.get(
      `/restapi/ui/blockpage?user_id=${user_id}`
    );

    commit("setCustomerBlockPage", response.data);
  },

  async updateCustomerBlockPage({ commit }, { body, user_id }) {
    const response = await this._vm.$http.post(
      `/restapi/ui/blockpage?user_id=${user_id}`,
      body
    );

    commit("setCustomerBlockPage", response.data);
  },

  async updateCustomerBlockPageForm({ commit }, { body, user_id }) {
    const response = await this._vm.$http.post(
      `/restapi/ui/blockpage?user_id=${user_id}`,
      body,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    commit("setCustomerBlockPage", response.data);
  },

  async resetCustomerBlockPage({ dispatch }, { user_id }) {
    const response = await this._vm.$http.delete(
      `/restapi/ui/blockpage?user_id=${user_id}`
    );

    if (response.data.code === 200)
      await dispatch(
        "blockPage/fetchCustomerBlockPage",
        { user_id },
        { root: true }
      );
  },

  // Global Block page

  async fetchGlobalBlockPage({ commit }) {
    const response = await this._vm.$http.get(`/restapi/ui/blockpage`);

    commit("setGlobalBlockPage", response.data);
  },

  async updateGlobalBlockPage({ commit }, { body }) {
    const response = await this._vm.$http.post(`/restapi/ui/blockpage`, body);

    commit("setGlobalBlockPage", response.data);
  },

  async resetGlobalBlockPage({ dispatch }) {
    const response = await this._vm.$http.delete(`/restapi/ui/blockpage`);

    if (response.data.code === 200)
      await dispatch("blockPage/fetchGlobalBlockPage", null, { root: true });
  },

  // MSP Global page

  async fetchMspBlockPage({ commit }, { msp_id }) {
    const response = await this._vm.$http.get(
      `/restapi/ui/blockpage?msp_id=${msp_id}`
    );

    commit("setMspBlockPage", response.data);
  },

  async updateMspBlockPage({ commit }, { body, msp_id }) {
    const response = await this._vm.$http.post(
      `/restapi/ui/blockpage?msp_id=${msp_id}`,
      body
    );

    commit("setMspBlockPage", response.data);
  },

  async updateMspBlockPageMeta({ commit }, { body, msp_id }) {
    const response = await this._vm.$http.post(
      `/restapi/ui/blockpage?msp_id=${msp_id}`,
      body,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    commit("setMspBlockPage", response.data);
  },

  async resetMspBlockPage({ dispatch }, { msp_id }) {
    const response = await this._vm.$http.delete(
      `/restapi/ui/blockpage?msp_id=${msp_id}`
    );
    if (response.data.code === 200)
      await dispatch("blockPage/fetchMspBlockPage", { msp_id }, { root: true });
  },
};

const mutations = {
  setCustomerBlockPage: (state, data) => (state.customerBlockPage = data),
  setMspBlockPage: (state, data) => (state.mspBlockPage = data),
  setGlobalBlockPage: (state, data) => (state.globalBlockPage = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
